import React from 'react';
import { CurricularClass112023 } from 'views/CurricularClass52023/components';

const ExtraCurricularActivitiesPage = () => {
  return <CurricularClass112023 />;
};

export default ExtraCurricularActivitiesPage;
